import { NewsListItemFragment } from '@amf/shared/types/graphql';
import React, { useMemo } from 'react';
import NewsListItem from '@amf/shared/components/news/NewsListItem';

interface PlayerNewsProps {
  title: string;
  news: NewsListItemFragment[];
  prefixes: {
    news: string;
  };
}

function PlayerNews({ title, news: originalNews, prefixes }: PlayerNewsProps) {
  const news = useMemo<NewsListItemFragment[]>(
    () =>
      originalNews.sort((a, b) => {
        if (a.publishedAt === b.publishedAt) return 0;
        return a.publishedAt < b.publishedAt ? 1 : -1;
      }),
    [originalNews],
  );
  return (
    <div className='PlayerNews'>
      <h2 className='PlayerNews__title'>{title}</h2>
      <div className='PlayerNews__items'>
        {news.map(item => (
          <NewsListItem key={item.id} news={item} prefix={prefixes.news} />
        ))}
      </div>
    </div>
  );
}

export default PlayerNews;
